import React from 'react'

const FormErrorText = ({ msg }) => {
    return (<div className='tw-text-red-600 tw-text-xs tw-mt-1'>{msg}</div>)
}

export { FormErrorText }
